<script>
    export let fill = '#000'
</script>

<style>
    svg {
        position: absolute;
        top: 400px;
        right: 14px;
        width: 131.28px;
        height: 36.69px;
    }

    .bgFill {
        fill: var(--bgColor);
    }
</style>

<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 438.77 102.49" style="--bgColor: {fill};">
    <g>
        <circle class="bgFill" cx="51.24" cy="51.24" r="51.24"/>
        <circle class="bgFill" cx="163.34" cy="51.24" r="51.24"/>
        <circle class="bgFill" cx="275.43" cy="51.24" r="51.24"/>
        <circle class="bgFill" cx="387.53" cy="51.24" r="51.24"/>
    </g>
</svg>